import { Qonty } from "@components/Qonty";
import { VerticalContainer } from "@shared/designSystem/Containers";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

interface QontyEmptyStateProps {
    text: string;
    qontyHeight?: string;
    qontyWidth?: string;
    darkMode?: boolean;
    className?: string;
    fullSize?: boolean;
}

export const QontyEmptyState: React.FC<QontyEmptyStateProps> = ({
    text,
    qontyHeight = "90px",
    qontyWidth = "90px",
    darkMode,
    className = "QontyEmptyState",
    fullSize = true,
}) => {
    return (
        <VerticalContainer
            className={className}
            height={fullSize ? "100%" : "auto"}
            width={fullSize ? "100%" : "auto"}
            alignment="center"
            justifyContent="center"
            gap={designSystemStyles.gapSm}
        >
            <Qonty
                height={qontyHeight}
                width={qontyWidth}
                blackAndWhite={true}
                opacity={0.4}
                darkMode={darkMode}
            />
            <Text
                text={`**${text.trim()}**`}
                alignment="center"
                color={designSystemStyles.colorTextSecondary}
                markdown={true}
            />
        </VerticalContainer>
    );
};
